import { isObject } from 'lodash';

import {
  LOGIN_START,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  CHECK_START,
  CHECK_SUCCESS,
  CHECK_FAILURE,
  VERIFY_START,
  VERIFY_SUCCESS,
  VERIFY_FAILURE,
  COMPLETE_SETUP,
  TOUR_LOADED,
  TOUR_STEPS_VIEWED
} from './actions';

const initialState = {
  logginIn: false,
  success: false,
  authenticated: false,
  loginError: false,
  checkingToken: false,
  user: null,
  verifying: false,
  tour: []
};

export default (state = {}, action) => {
  const newState = Object.assign({}, initialState, state);

  switch (action.type) {
    case LOGIN_START:
      newState.loggingIn = true;
      newState.success = false;
      newState.authenticated = false;
      newState.loginError = false;
      break;
    case LOGIN_SUCCESS:
      newState.loggingIn = false;
      newState.success = true;
      newState.authenticated = true;
      newState.loginError = false;
      newState.user = action.payload;
      break;
    case LOGIN_FAILURE:
      newState.loggingIn = false;
      newState.success = false;
      newState.authenticated = false;
      newState.loginError = action.payload;
      newState.user = null;
      break;
    case LOGOUT:
      newState.authenticated = false;
      newState.logginIn = false;
      newState.checkingToken = false;
      newState.user = null;
      break;
    case CHECK_START:
      newState.checkingToken = true;
      break;
    case CHECK_SUCCESS:
      newState.checkingToken = false;
      newState.authenticated = true;
      newState.user = action.payload;
      break;
    case CHECK_FAILURE:
      newState.checkingToken = false;
      break;
    case VERIFY_START:
      newState.verifying = true;
      break;
    case VERIFY_SUCCESS:
      newState.verifying = false;
      if (newState.hasOwnProperty('user')) {
        if (!isObject(newState.user)) {
          newState.user = {};
        }
        newState.user.verified = action.payload.verified;
      }
      break;
    case VERIFY_FAILURE:
      newState.verifying = false;
      break;
    case COMPLETE_SETUP:
      if (newState.user) {
        newState.user.setup_complete = true;
      }
      break;
    case TOUR_LOADED:
      newState.tour = action.payload;
      break;
    case TOUR_STEPS_VIEWED:
      newState.tour = newState.tour.map(t => {
        if (action.payload.includes(t.id)) {
          t.viewed = true;
        }
        return t;
      });
      break;
    default:
      // oh well!
      break;
  }
  return newState;
};



// WEBPACK FOOTER //
// ./src/components/app/login/reducer.js